const modalDefaultState = {
  openModalImportSheet: false, // open modal import sheet file
  // open modal that imports a sheet into a brand-new presentation (used outside the editor, e.g. Home)
  openModalImportSheetNewPresentation: false,
  isAIRequestLimitModalVisible: false,
  isShowModalTemplateLibrary: false,
  // Set when an external trigger wants the template library modal to open at
  // a specific category. Consumed once by TemplateLibraryModal, then cleared.
  initialTemplateLibraryCategoryId: null,
  // Non-null when the open was triggered by a deep link; the value is the
  // route fullPath to be reported in analytics. Cleared by the modal once
  // the deep-link analytics event has fired.
  templateLibraryDeepLinkSource: null,
}

export default modalDefaultState
